import { useEffect } from 'react';

interface UseIntersectionObserverProps {
    targetRef: React.RefObject<HTMLElement | null>;
    onIntersect?: () => void;
    threshold?: number;
    rootMargin?: string;
    enabled?: boolean;
}

export const useIntersectionObserver = ({
    targetRef,
    onIntersect,
    threshold = 0,
    rootMargin = '0px',
    enabled = true,
}: UseIntersectionObserverProps) => {
    useEffect(() => {
        if (!enabled || !targetRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && onIntersect) {
                        onIntersect();
                    }
                });
            },
            {
                threshold,
                rootMargin,
            }
        );

        observer.observe(targetRef.current);

        return () => {
            observer.disconnect();
        };
    }, [targetRef, onIntersect, threshold, rootMargin, enabled]);
};
